/**
 * PreviewTrust — Trust bar with value/label items
 */

interface TrustItem {
  value: string;
  label: string;
}

interface PreviewTrustProps {
  data: {
    items?: TrustItem[];
  };
  settings: {
    [key: string]: any;
  };
}

export function PreviewTrust({ data, settings }: PreviewTrustProps) {
  return (
    <section className="preview-trust">
      <div className="preview-container">
        <div className="preview-trust__inner">
          {data.items?.map((item, i) => (
            <div key={i} className="preview-trust__item">
              <div className="preview-trust__value">{item.value}</div>
              <div className="preview-trust__label">{item.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
